import { render, staticRenderFns } from "./TbModule.vue?vue&type=template&id=448d5e97&scoped=true"
import script from "./TbModule.vue?vue&type=script&lang=js"
export * from "./TbModule.vue?vue&type=script&lang=js"
import style0 from "./TbModule.vue?vue&type=style&index=0&id=448d5e97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448d5e97",
  null
  
)

export default component.exports